
import { useContext, useEffect } from 'react';
import Dashboard_Products_Item from './Dashboard_Products_Item';
import { DashboardContext } from '../../../contextApi/DashboardContext';

export default function Dashboard_Products({website, setEditPage}) {
  const {productsList, setProductsList} = useContext(DashboardContext);
  useEffect(()=>{
    setProductsList(() => website?.settings?.categories?.flatMap(cat =>cat?.products));
  },[website])

  const deployProducts=()=>{
    if(productsList.length === 0)return;
    return productsList.map((item, inx)=>{
      return <Dashboard_Products_Item key={`dashboard_products_item_${inx}`} website={website} item={item} setEditPage={setEditPage}/>
    })
  }

  return (
    <div style={{width:"100%", marginBottom:"50px"}}>
      <h2>המוצרים שלי</h2>
      {productsList.length > 0 ? 
        <div className="dashboard_products">
          {deployProducts()}
        </div> :
        <h3 style={{margin:"40px auto"}}>רשימת המוצרים ריקה</h3>
      }
    </div>
  )
}
